/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_OcopInputs */

const vi_media_field_ocop = /** @type {(inputs: Media_Field_OcopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giấy chứng nhận OCOP`)
};

/**

* @param {Media_Field_OcopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_ocop = /** @type {((inputs?: Media_Field_OcopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_OcopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_ocop(inputs)
});